export type SubscriptionStatus = 'active' | 'past_due' | 'canceled' | 'incomplete' | 'trialing';

export interface Subscription {
  id: string;
  shop_id: string;
  owner_id: string;
  stripe_subscription_id: string;
  stripe_customer_id: string;
  status: SubscriptionStatus;
  plan_id: 'monthly' | 'annual' | 'basic' | 'basic_annual';
  current_period_end: string;
  cancel_at_period_end: boolean;
  created_at: string;
}

export interface PricingPlan {
  id: string;
  name: string;
  price: number;
  currency: string;
  interval: 'month' | 'year';
  features: string[];
  trial_days?: number;
}

export const BASIC_PLAN: PricingPlan = {
  id: 'basic',
  name: 'Basic Barber Shop',
  price: 29.99,
  currency: 'CHF',
  interval: 'month',
  trial_days: 14,
  features: [
    'Up to 3 Barbers',
    'Unlimited Bookings',
    'Standard Analytics',
    'Email Notifications',
    'Multi-language Support'
  ]
};

export const MONTHLY_PLAN: PricingPlan = {
  id: 'monthly',
  name: 'Pro Barber Shop',
  price: 49.99,
  currency: 'CHF',
  interval: 'month',
  trial_days: 14,
  features: [
    'Unlimited Barbers',
    'Unlimited Bookings',
    'Custom Services & Categories',
    'Real-time Dashboard',
    'Email Notifications',
    'Multi-language Support',
    'Priority Support',
    'Advanced Analytics'
  ]
};

export const ANNUAL_PLAN: PricingPlan = {
  id: 'annual',
  name: 'Pro Barber Shop (Annual)',
  price: 499.90, // ~10 months price (2 months free)
  currency: 'CHF',
  interval: 'year',
  trial_days: 14,
  features: [
    ...MONTHLY_PLAN.features
  ]
};

export const BASIC_ANNUAL_PLAN: PricingPlan = {
  id: 'basic_annual',
  name: 'Basic Barber Shop (Annual)',
  price: 299.90, // ~10 months price (2 months free)
  currency: 'CHF',
  interval: 'year',
  trial_days: 14,
  features: [
    ...BASIC_PLAN.features
  ]
};
